import React from 'react';
import "./styles/username.css";

const UsernameStep = ({ formData, updateFormData }) => {
  return (
    <div className="step-content username-step">
      <h2>Choose your name</h2>
      <input
        type="text"
        value={formData.name}
        onChange={(e) => {
          e.preventDefault();
          updateFormData('name', e.target.value);
        }}
        placeholder="Enter name"
      />
    </div>
  );
};

export default UsernameStep;
